import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'groupBy' })
export class GroupByPipe implements PipeTransform {
    transform(value: Array<any>, fields: Array<any>): Array<any> {
        const groupedObj = value.reduce((prev, cur) => {
            let key = '';
            fields.forEach((item) => { key = key + cur[item] });
            if (!prev[key]) {
                prev[key] = [cur];
            } else {
                prev[key].push(cur);
            }
            return prev;
        }, {});
        return Object.keys(groupedObj).map(key => {
            return { key, value: groupedObj[key] };
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/common/pipes/group-by.pipe.ts